import * as React from 'react'
import { Form, FormGroup, Col, ControlLabel, FormControl } from 'react-bootstrap';

export const Dropdown = ({ options, title, show, className, ...htmlProps }: DropdownProps): JSX.Element => {
    return show
        ? (<Form turn-autofill-off horizontal>
            <FormGroup controlId="formControlsSelect">
                <Col componentClass={ControlLabel} sm={6}>{title}</Col>
                <Col sm={6}>
                    <FormControl {...htmlProps} componentClass="select">
                        <option value="" key="">View All</option>
                        {options.map(value => <option value={value} key={value}>{value}</option>)}
                    </FormControl>
                </Col>
            </FormGroup>
        </Form>)
        : null;

}

interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    show: boolean,
    title: string,
    options: string[]
}
